'use strict';

import Evented from '../../ui/modules/evented';
import MapUIMapboxInstance from './map-ui-mapbox-instance';

export default class MapUIContainer extends Evented {

  constructor( options ) {

    _wp.c.d && console.log( 'new MapUIContainer', options );

    super();

    this.options = options;
    this.instance = null;

    window.map_ui.fire( 'map.registered', { container: this } );
    setTimeout( () => { this._pre_init(); }, 0 );

  };

  _pre_init() {

    window.map_ui.fire( 'map.pre_init', { container: this } );
    setTimeout( () => { this._prepare_options(); }, 0 );

  };

  _prepare_options() {

    const path_default_options = {

      width: 3,
      color: map_ui.color.purple,
      min_zoom: 9,
      show_data_markers: true,

      color_icons: 'all',

    };
    const elevation_default_options = {

      width: 3,
      color: map_ui.color.purple,
      min_zoom: 9,

      color_icons: 'all',

      view_3d: false,

    };

    this.options = _f.extend( {

      engine: 'mapbox',

      dom_id: 'map',

      zoom: false,
      bearing: false,
      zoom_range: false,
      label_default_zoom_range: false,
      center: false,

      title: false,

      add_white_overlay: false,

      map_style: map_ui.default,

      // <base_locations> should be used for a base layer. Useful data should be passed in <locations>
      base_locations: [],
      locations: [],

    }, this.options );

    if ( undefined !== this.options.path ) {

      if ( Array.isArray( this.options.path ) ) {

        this.options.path = this.options.path.map( ( value ) => {
          return _f.extend( Object.assign( {}, path_default_options ), value );
        } );

      }
      else if ( 'object' !== typeof name ) {
        this.options.path = _f.extend( Object.assign( {}, path_default_options ), this.options.path );
      }

    }

    if ( undefined !== this.options.elevation ) {

      if ( Array.isArray( this.options.elevation ) ) {

        this.options.elevation = this.options.elevation.map( ( value ) => {
          return _f.extend( Object.assign( {}, elevation_default_options ), value );
        } );

      }
      else if ( 'object' !== typeof name ) {
        this.options.elevation = _f.extend( Object.assign( {}, elevation_default_options ), this.options.elevation );
      }

    }

    // Decompile data

    if ( false !== this.options.center ) {
      this.options.center = this.options.center.map( parseFloat );
    }
    if ( false !== this.options.zoom ) {
      this.options.zoom = ( 'mapbox' === this.options.engine ) ? parseFloat( this.options.zoom ) : parseInt( this.options.zoom, 10 );
    }
    if ( false !== this.options.label_default_zoom_range ) {
      this.options.label_default_zoom_range = this.options.label_default_zoom_range.map( parseFloat );
    }
    else {
      this.options.label_default_zoom_range = [ 7, 22 ];
    }

    if ( undefined !== this.options.kml ) {
      this.options.path = this.options.kml;
    }

    this.options.locations = [].concat(

      this.options.base_locations.map(

        ( data ) => {

          const extra_data = _f.extend( {}, { in_bounds: false, bearing: 0 }, ( undefined !== data[ 5 ] ? data[ 5 ] : {} ) );
          const d = _f.extend( [], [

            false, // label
            false, // lat
            false, // lng
            'city', // style
            [ this.options.label_default_zoom_range[ 0 ], this.options.label_default_zoom_range[ 1 ] ], // zoom
            extra_data, // extra options

            ], data );
          d[ 5 ] = extra_data;
          return d;

        }

      ),
      this.options.locations.map(

        ( data ) => {

          const extra_data = _f.extend( {}, { in_bounds: true }, ( undefined !== data[ 5 ] ? data[ 5 ] : {} ) );
          const d = _f.extend( [], [

            false, // label
            false, // lat
            false, // lng
            'city', // style
            [ this.options.label_default_zoom_range[ 0 ], this.options.label_default_zoom_range[ 1 ] ], // zoom
            extra_data // extra options

            ], data );
          d[ 5 ] = extra_data;
          return d;

        }

      )

    );

    this.fire( 'map.prepare_options' );
    window.map_ui.fire( 'map.prepare_options', { container: this } );

    setTimeout( () => { this._load_and_fire_map(); }, 0 );

  };

  _bounceEvent( e ) {
    this.fire( e.type, { instance: this.instance, container: this } );
  };

  async _load_and_fire_map() {

    await this._load_engine( this.options.engine );

    switch ( this.options.engine ) {

      case 'mapbox':
        this.instance = new MapUIMapboxInstance( this );
        break;

      default:
        throw new Error( `Undefined engine (${options.engine})` );

    }

    if ( null !== this.instance ) {
      [ 'style.load', 'map.init', 'map.load' ].forEach( eventName => this.instance.on( eventName, this._bounceEvent.bind( this ) ) );
    }

  };

  async _load_engine( engine ) {

    switch ( engine ) {

      case 'mapbox':
        await map_ui._load_file_if( map_ui._engines.mapbox_css );
        await map_ui._load_file_if( map_ui._engines.mapbox_js );
        break;

      case 'd3':
        await map_ui._load_file_if( map_ui._engines.d3_js );
        break;

      default:
        throw new Error( `Unknow engine (${engine})` );

    }

  };

}
